<script>

import { Overlay } from '../../'

export default {
    name: 'AwesomeOscillator',
    mixins: [Overlay],
    methods: {
        meta_info() {
            return {
                author: 'StdSquad', version: '1.0.0',
                desc: 'Awesome Oscillator - Momentum indicator by Bill Williams',
                preset: {
                    name: 'AO $fast $slow',
                    side: 'offchart',
                    settings: {
                        lineWidth: 1.5,
                        color: '#4caf50'
                    }
                }
            }
        },
        use_for() { return ['AwesomeOscillator'] },
        calc() {
            return {
                props: {
                    fast: { def: 5, text: 'Fast Period' },
                    slow: { def: 34, text: 'Slow Period' }
                },
                conf: { renderer: 'Histogram' },
                update: `
                    let median = ts((high[0] + low[0]) / 2)
                    return sma(median, fast)[0] - sma(median, slow)[0]
                `
            }
        }
    }
}
</script>
